import React from 'react';
import { useParams } from 'react-router-dom';
import {
  CookbookCategoriesConnectorApollo,
  CookbookTagsConnectorApollo,
  useTimestamp,
} from '@front-activerse/common-components';
import CookbookTagListContainer from './CookbookTagListContainer';

const CookbookTagListPage: React.FC = () => {
  const { timestamp2 } = useTimestamp();
  const { dietTypeTagId } = useParams();

  const dietTypeTags = [dietTypeTagId ? +dietTypeTagId : 0];

  return (
    <CookbookCategoriesConnectorApollo>
      {(cookbookCategoriesData) => (
        <CookbookTagsConnectorApollo dietTypeTags={dietTypeTags}>
          {(cookbookTagListData) => (
            <CookbookTagListContainer
              {...cookbookTagListData}
              {...cookbookCategoriesData}
              loading={cookbookTagListData.loading || cookbookCategoriesData.loading}
              tagId={dietTypeTagId}
              key={timestamp2}
            />
          )}
        </CookbookTagsConnectorApollo>
      )}
    </CookbookCategoriesConnectorApollo>
  );
};

export default CookbookTagListPage;
